import { FormControl, FormControlLabel, Switch } from '@mui/material';
import React from 'react';
import { Control, useController } from 'react-hook-form';

export interface VisibilityFieldProps {
  control: Control<any>;
  name: string;
}

const VisibilityField = ({ control, name }: VisibilityFieldProps) => {
  const {
    field: { value, ...field },
  } = useController({ control, name });

  return (
    <FormControl>
      <FormControlLabel
        control={<Switch checked={value} {...field} />}
        label="Assessment visible for students"
        sx={{ textAlign: 'left' }}
      />
    </FormControl>
  );
};

export default VisibilityField;
